/* MM / Panel — assets/mm-panel.js
   Ouverture / fermeture du châssis commun des side panels : délégation
   document UNIQUE et GARDÉE (les previews ré-exécutent les scripts, un
   listener non gardé se cumulerait — contre-exemple documenté du menu
   mobile). Contrat : [data-panel-open] + aria-controls="{id}" ouvre le
   .mm-panel correspondant ; [data-panel-close] (croix, scrim) ferme ;
   Échap ferme ; scroll de page verrouillé sur documentElement (pattern
   video-details, jamais body).
   Règles multi-panneaux (revue du 31/07) : un seul panneau ouvert à la
   fois — ouvrir ferme l'existant — et le verrou de scroll ne se relâche
   que quand plus AUCUN panneau n'est ouvert.
   Focus : déplacé sur la croix à l'ouverture, restitué au déclencheur à
   la fermeture (le piège complet type inert serait une première dans le
   kit — hors périmètre, cf. revue). */
   (function () {
	'use strict';
  
	function setOpen(panel, open) {
	  if (open) {
		/* un seul panneau ouvert à la fois : ouvrir ferme l'existant */
		document.querySelectorAll('.mm-panel.is-open').forEach(function (p) {
		  if (p !== panel) setOpen(p, false);
		});
	  }
	  panel.classList.toggle('is-open', open);
	  /* Classe .stop-scrolling (convention du kit, cf. mm_cart.js / mm_navigation.js)
	     plutôt qu'un style inline. On ADD sans condition à l'ouverture, mais on ne
	     REMOVE que si plus aucun panel ET aucun autre overlay connu (cart, menu
	     mobile) n'est ouvert — sinon on retire un verrou posé par cet autre
	     overlay, même piège que documenté dans mm_navigation.js. */
	  var anyPanelOpen = document.querySelector('.mm-panel.is-open');
	  if (anyPanelOpen) {
		document.documentElement.classList.add('stop-scrolling');
	  } else {
		var otherOverlayOpen = document.querySelector('.mm-dc-is-open, .mm-drawer-open, .mm-open');
		if (!otherOverlayOpen) document.documentElement.classList.remove('stop-scrolling');
	  }
	  document.querySelectorAll('[data-panel-open][aria-controls="' + panel.id + '"]').forEach(function (t) {
		t.setAttribute('aria-expanded', open ? 'true' : 'false');
	  });
  
	  if (open) {
		/* Le contenu d'un panneau entre en scène EN BLOC, à l'ouverture. Le
		   laisser à l'IntersectionObserver de MmMotion ne marche pas : mesuré
		   dans le portail, les cartes du guide des tailles restaient à opacité
		   0 — y compris panneau plein écran, contenu entièrement dans le
		   viewport et après un nouveau scan. C'est donc à l'ouverture de
		   révéler ce qu'elle expose.
		   Le reflux forcé n'est pas décoratif : le panneau quitte
		   visibility:hidden dans ce même recalcul de style, et poser mm-in dans
		   la foulée démarre la transition sur un sous-arbre encore masqué, que
		   Chromium fige — elle reste « running » sans jamais avancer et le
		   contenu ne réapparaît plus jamais (mesuré : opacité 0 définitive).
		   Lire offsetHeight force le layout AVEC le panneau visible, ce qui
		   donne à la transition un état de départ valide. C'est le même geste
		   que le portalize() du sélecteur de taille. Les délais de
		   data-mm-stagger sont déjà posés : la cascade se joue quand même. */
		var enAttente = panel.querySelectorAll('[data-mm-reveal]:not(.mm-in)');
		if (enAttente.length) {
		  void panel.offsetHeight;
		  Array.prototype.forEach.call(enAttente, function (el) { el.classList.add('mm-in'); });
		  /* Filet, comme le cleanup de MmMotion après une entrée jouée : on
			 retire l'attribut. C'est LUI qui impose opacity:0 — sans ce retrait,
			 une transition qui n'a pas pu avancer (onglet en arrière-plan, iframe
			 non peinte) laisserait le contenu invisible pour de bon. */
		  window.setTimeout(function () {
			Array.prototype.forEach.call(enAttente, function (el) {
			  el.removeAttribute('data-mm-reveal');
			  el.style.removeProperty('--mm-delay');
			});
		  }, 1200);
		}
		var closeBtn = panel.querySelector('.mm-panel__close');
		if (closeBtn) closeBtn.focus();
	  } else {
		/* ancre de focus PAR PANNEAU : une ouverture exclusive qui ferme le
		   panneau précédent restitue son focus à lui, puis pose le sien —
		   un état global se ferait consommer par cette fermeture croisée */
		var opener = panel.__mmOpener;
		panel.__mmOpener = null;
		if (opener && document.contains(opener)) opener.focus();
	  }
	}
  
	function open(id, opener) {
	  var panel = document.getElementById(id || '');
	  if (panel && panel.classList.contains('mm-panel')) {
		panel.__mmOpener = opener || document.querySelector('[data-panel-open][aria-controls="' + panel.id + '"]');
		setOpen(panel, true);
	  }
	}
	function close(id) {
	  var panel = id ? document.getElementById(id) : document.querySelector('.mm-panel.is-open');
	  if (panel && panel.classList.contains('mm-panel')) setOpen(panel, false);
	}
  
	if (!window.__mmPanelWired) {
	  window.__mmPanelWired = true;
  
	  document.addEventListener('click', function (e) {
		var opener = e.target.closest('[data-panel-open]');
		if (opener) {
		  open(opener.getAttribute('aria-controls'), opener);
		  return;
		}
		var closer = e.target.closest('[data-panel-close]');
		if (closer) {
		  var panel = closer.closest('.mm-panel');
		  if (panel) setOpen(panel, false);
		}
	  });
  
	  document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') close();
		if (e.key !== 'Tab') return;
		var openPanel = document.querySelector('.mm-panel.is-open');
		if (!openPanel) return;
		var box = openPanel.querySelector('.mm-panel__box') || openPanel;
		var focusables = Array.prototype.filter.call(
		  box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'),
		  function (el) { return el.getClientRects().length > 0; }
		);
		if (!focusables.length) return;
		var first = focusables[0];
		var last = focusables[focusables.length - 1];
		if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
		else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
		else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
	  });
	}
  
	window.MmPanel = { open: open, close: close };
  })();
  